export default (obj) => {

  const json = JSON.stringify(obj)

  return JSON.parse(json)
}